import { StatusDot } from '@astryxdesign/core/StatusDot';
import { StatusLine } from '@/components/StatusLine';

const MAP = {
  confirmed: { variant: 'accent', label: 'Подтверждена' },
  checked_in: { variant: 'warning', label: 'Машина принята' },
  ready: { variant: 'success', label: 'Готово' },
  cancelled: { variant: 'error', label: 'Отменена' },
  no_show: { variant: 'neutral', label: 'Не приехал' },
} as const;

export type BookingStatus = keyof typeof MAP;

export function BookingStatusDot({ status }: { status: BookingStatus }) {
  const s = MAP[status];
  return <StatusDot variant={s.variant} label={s.label} />;
}

/** Dot plus the status in words. */
export function BookingStatusLine({ status, size }: { status: BookingStatus; size?: 'xsm' | 'sm' }) {
  const s = MAP[status];
  return <StatusLine variant={s.variant} label={s.label} size={size} />;
}

export const statusLabel = (s: BookingStatus) => MAP[s].label;
